/**
 * Localised role labels for the messaging surfaces (presentation only).
 *
 * The canonical role vocabulary stays in `canonicalRoleLabels.js` — this
 * module adds NOTHING to it and defines no map of its own: it looks the
 * canonical role_id up in the translation catalogue and falls back to the
 * canonical English label when a locale has no entry. No new role
 * authority, no second vocabulary.
 */
import { roleLabel } from './canonicalRoleLabels';

export const localisedRoleLabel = (roleId, t) => {
  if (!roleId || typeof roleId !== 'string') return roleLabel(roleId);
  if (typeof t !== 'function') return roleLabel(roleId);
  return t(`provider.messaging.roles.${roleId}`, { defaultValue: roleLabel(roleId) });
};

/**
 * The canonical unassigned pool. Its backend name ("System Pool (Unassigned)")
 * is an internal string and must never reach a user-facing label — every
 * surface renders the translated pool badge instead.
 */
export const isSystemPoolAssignee = (thread) => (
  thread?.assigned_agent_id === 'SYSTEM_POOL'
  || /^System Pool/i.test(thread?.assigned_agent_name || '')
);
